import {useEffect, useRef} from 'react'

export default () => {
    const refKeys = useRef({
        alt: false,
        ctrl: false,
        shift: false,
        meta: false,
        other: new Set,
    })

    useEffect(
        () => {
            const ac = new AbortController()
            const {signal} = ac

            window.addEventListener(
                'keydown',

                e => {
                    if (e.repeat) {
                        return
                    }

                    if ('Alt' === e.key) {
                        refKeys.current.alt = true
                    }
                    else if ('Control' === e.key) {
                        refKeys.current.ctrl = true
                    }
                    else if ('Meta' === e.key) {
                        refKeys.current.meta = true
                    }
                    else if ('Shift' === e.key) {
                        refKeys.current.shift = true
                    }
                    else {
                        refKeys.current.other.add(e.key)
                    }
                },

                {capture: true, signal}
            )

            window.addEventListener(
                'keyup',

                e => {
                    if ('Alt' === e.key) {
                        refKeys.current.alt = false
                    }
                    else if ('Control' === e.key) {
                        refKeys.current.ctrl = false
                    }
                    else if ('Meta' === e.key) {
                        refKeys.current.meta = false
                    }
                    else if ('Shift' === e.key) {
                        refKeys.current.shift = false
                    }
                    else {
                        refKeys.current.other.delete(e.key)
                    }
                },

                {capture: true, signal}
            )

            return () => ac.abort()
        },

        []
    )

    return refKeys.current
}
